<template>
  <div class="all_order">
    <div class="condition">
      <div class="order_steps">
      </div>

      <div class="screen_input">
        <div>
          订单编号
          <el-input
            class="screen"
            v-model="params.orderNo"
            placeholder="请输入订单编号"
            type="number"
          ></el-input>
        </div>
        <div>
          客户信息
          <el-input
            class="screen"
            v-model="params.customer"
            placeholder="请输入客户姓名或手机号"
          ></el-input>
        </div>
        <div>
          师傅信息
          <el-input
            class="screen"
            v-model="params.worker"
            placeholder="请输入师傅姓名或手机号"
          ></el-input>
        </div>
        <div>
          订单状态
          <el-select
            class="screen"
            v-model="params.status"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <!-- <div>
          退款单号
          <el-input
            class="screen"
            v-model="params.refundNo"
            placeholder="请输入退款单号"
            type="number"
          ></el-input>
        </div> -->
        <div id="range_date">
          申请时间
          <el-date-picker
            class="screen range_date"
            v-model="timeSlot"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </div>
        <div>
          <el-button class="order_search" @click="orderSearch()"
            >搜索</el-button
          >
          <el-button class="order_clear" @click="orderClear()">重置</el-button>
        </div>
      </div>

      <div class="check_type">
        <div
          class="check_item"
          v-for="(item, index) in orderType"
          :key="index"
          :class="{ order_type_isSelected: item.isSelected }"
          @click="checkOrderType(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>

    <div class="order-list" v-loading="loadling">
      <order-list
        :orderItems="orderItems"
        v-on:pagesize="pagesize"
      ></order-list>
    </div>
  </div>
</template>

<script>
import orderList from "./order_list";
export default {
  components: {
    orderList
  },
  data() {
    return {
      loadling:false,
      orderType: [
        { name: "全部", isSelected: true, status: "" },
        { name: "审核中", isSelected: false, status: "WAIT" },
        { name: "退款拒绝", isSelected: false, status: "REFUSE" },
        { name: "退款失败", isSelected: false, status: "FAIL" },
        { name: "退款成功", isSelected: false, status: "SUCCESS" },
        { name: "退款取消", isSelected: false, status: "CANCEL" },
        { name: "退款仲裁中", isSelected: false, status: "ARBITRATION" },
      ],
      options: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      timeSlot: ["", ""],
      orderItems: {},
      page: "1",
      params: {
        pageNum: 1,
        pageSize: 6,
        orderNo: "", //订单号
        customer: "", //客户姓名或手机
        worker: "", //师傅姓名或手机
        status: "",
        startTime: "",
        endTime: "",
        isArrival: "" //是否到货
      }
    };
  },
  activated() {
    var _this = this;
    for (let i of _this.$store.state.userList) {
      i.isSelected = false;
      if (i.name == "退款订单") {
        i.isSelected = true;
      }
    }
    _this.orderSearch();
    this.$post(`/order/api/refund/status`).then(res => {
      if (res.code == 0) {
        _this.options = res.data;
      } else {
        this.$message(res.message);
      }
    });
  },
  // mounted() {
  //   var _this = this;
  //   for (let i of _this.$store.state.userList) {
  //     i.isSelected = false;
  //     if (i.name == "退款订单") {
  //       i.isSelected = true;
  //     }
  //   }
  //   _this.orderSearch();
  //   this.$post(`/order/api/order/status`).then(res => {
  //     if (res.code == 0) {
  //       _this.options = res.data;
  //     } else {
  //       this.$message(res.message);
  //     }
  //   });
  // },

  methods: {
    pagesize(val) {
      this.params.pageNum = val;
      this.orderSearch();
    },
    checkOrderType(item) {
      for (let i of this.orderType) {
        i.isSelected = false;
      }
      item.isSelected = true;
      this.params.pageNum=1
      this.params.status = item.status;
      this.orderSearch();
    },
    // 订单接口调用
    orderSearch() {
      var _this = this;
      var params = {};
      this.loadling=true
      _this.params.startTime = _this.timeSlot[0];
      _this.params.endTime = _this.timeSlot[1];
      for (let i in _this.params) {
        if (_this.params[i].length != 0) {
          params[i] = _this.params[i];
        }
      }
      this.$fetch(`/order/api/refund`, params).then(res => {
        if (res.code == 0) {
          res.data.refund = true;
          _this.orderItems = res.data;
        } else {
          this.$message(res.message);
        }
      }).finally(()=>this.loadling=false)
    },
    // 清除条件
    orderClear() {
      for (let i in this.params) {
        this.params[i] = "";
      }
      this.params.pageNum = 1;
      this.params.pageSize = 6;
      this.timeSlot = ["", ""];
      this.orderType.map(i => {
        i.isSelected = false;
        i.name == "全部" ? (i.isSelected = true) : "";
      });
      this.orderSearch();
    }
  }
};
</script>
<style lang="scss" scoped>
.screen_input>div{
  margin-bottom: 16px;
  // flex: 1 1;
  width: 266px;
}
.condition {
  // height: 288px;
  background: #fff;
  .order_steps {
    height: 108px;
    padding: 24px 101px;
    border-bottom: 1px solid #e8eef5;
    background: url("~@/assets/img/pic_xiadanliuchengrefund.png") no-repeat;
    background-size: cover;
    img {
      width: 679px;
      height: 32px;
      display: block;
      margin: 0 auto;
    }
    .steps_text {
      display: flex;
      justify-content: space-between;
      div {
        width: 48px;
        height: 12px;
        font-size: 12px;
        line-height: 1;
        color: #b4b7bc;
        margin-top: 16px;
        text-align: center;
      }
    }
  }
  .screen_input {
    padding: 24px 20px 0 20px;
    border-bottom: 1px solid #e8eef5;
    .screen {
      width: 210px;
      height: 30px;
      input {
        height: 30px;
        padding: 0 !important;
        line-height: 0;
      }
    }
    .order_search {
      width: 124px;
      height: 30px;
      background: #3455d3;
      border-color: #3455d3;
      border-radius: 2px;
      font-size: 14px;
      line-height: 5px;
      color: #fff;
      &:hover {
        background: #2c4abb;
        border-color: #2c4abb;
      }
    }
    .order_clear {
      width: 124px;
      height: 30px;
      border-radius: 2px;
      border: 1px solid rgba(180, 183, 188, 1);
      color: #5e6066;
      font-size: 14px;
      line-height: 5px;
      &:focus,
      &:hover {
        color: #3455d3;
        border-color: #3455d3;
        background: #fff;
      }
    }
  }
}
.check_type {
  padding: 14px 20px;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 13px;
  .check_item {
    margin-right: 36px;
    color: #2f3133;
    font-size: 14px;
    cursor: pointer;
    &:hover {
      color: #3455d3;
    }
  }
  .erji_item {
    width: 100%;
    margin-top: 8px;
    .er_btns {
      width: 56px;
      height: 26px;
      color: #909399;
      font-size: 12px;
      border-radius: 13px;
      background: #f9fafa;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border: none;
      line-height: 0;
    }
    .er_selected {
      background: #f8f9fe;
      color: #3455d3;
    }
  }
  .order_type_isSelected {
    color: #3455d3;
    font-weight: bold;
    border-bottom: 1px solid #3455d3;
    padding-bottom: 3px;
  }
}
</style>
